import { render, staticRenderFns } from "./PharmacyGroupActions.vue?vue&type=template&id=208f9bc1"
import script from "./PharmacyGroupActions.vue?vue&type=script&lang=js"
export * from "./PharmacyGroupActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports